<template>
  <div class="template-project-bread">
    <div class="left">
        <div class="back">
          <el-tooltip content="返回上一页">
            <i @click="handleBack" class="icon iconfont iconicon_arrow_task_2 activeIconHover"></i>
          </el-tooltip>
        </div>
          <!-- 背景选择 -->
          <ColorCardSmall
            :dataset="{ background_text: dataset.template_name }"
            :defaultText="dataset.template_name"
            :disabled="true"
            class="project-bread-color"
          ></ColorCardSmall>
        <div class="name">
          <el-tooltip class="item" effect="dark" content="修改模板名称" placement="top" v-if="!isEdit" @click.native="editTitle">
            <span>{{dataset.template_name}}</span>
          </el-tooltip>
          <el-input v-else ref="input" v-model="dataset.template_name" @blur="isEdit = false" @keyup.enter.native="isEdit = false"></el-input>
        </div>
    </div>
    <div class="right">
      <wf-button icon="icon iconfont iconicon_recycle_bin" plain type="danger" @click="del">删除</wf-button>
      <wf-button @click="save" icon="icon iconfont iconicon_document">保存模板</wf-button>
    </div>
  </div>

</template>
<script>
import ColorCardSmall from '@/components/colorControl/cardSmall'
import { mapState } from 'vuex'
export default {
  components: {
    ColorCardSmall
  },
  data() {
    return {
      isEdit: false
    }
  },
  // watch: {
  //   'dataset.name': {
  //     handler() {
  //       this.background_text = this.name
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // },
  computed: {
    ...mapState('template/template', {
      dataset: state => state.dataset
    })
  },
  methods: {
    handleBack() {
      this.$router.go(-1)
    },
    save() {
      this.$emit('save')
    },
    del() {
      this.$emit('del')
    },
    editTitle() {
      this.isEdit = true
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    }
  },
}
</script>
<style lang="scss">
.template-project-bread {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  .project-bread-color {
    margin-left: 10px;
    display: inline-flex;
  }
  .name {
    font-weight: 700;
    margin: 0 18px 0 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .left {
    display: flex;
    align-items: center;
  }
  .right {
    display: flex;
    align-items: center;
    >*:last-child {
      margin-left: 16px;
    }
  }
}
</style>
